import React from 'react'
import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star';
import { Box, Divider, FormControl, FormLabel, Typography } from '@mui/material';
import { StarBorderRounded, StarRateRounded } from '@mui/icons-material';

const labels: { [index: string]: string } = {
    1: 'Poor',
    2: 'Below Average',
    3: 'Average',
    4: 'Good',
    5: 'Flawless',
};

function getLabelText(value: number) {
    return `${value} Star${value !== 1 ? 's' : ''}, ${labels[value]}`;
}

interface FormDetailProps {
    type: any;
    label: any;
    value: any;
    setValue: any;
}

interface FormComponentProps {
    FormDetail: FormDetailProps;
}
const FormComponent: React.FC<FormComponentProps> = ({ FormDetail }) => {

    switch (FormDetail.type) {
        case "rating":
            return (
                <FormControl className='w-100'>
                    <FormLabel className='mb-1'>{FormDetail.label}</FormLabel>
                    <Box width='100%'>
                        <Box className='d-flex align-items-center w-100 justify-contnet-between' border='1px solid #a3a3a3' borderRadius='10px' >
                            <Rating
                                className='m-0 p-0 w-75 p-2 pe-0'
                                sx={{ borderRight: '1px solid #a3a3a3' }}
                                name="integer-rating"
                                value={FormDetail.value}
                                getLabelText={getLabelText}
                                onChange={(event, newValue) => {
                                    FormDetail.setValue(newValue);
                                }}
                                icon={<StarRateRounded style={{ fontSize: '40px' }} />}
                                emptyIcon={<StarRateRounded style={{ opacity: 0.4, fontSize: '40px' }} />}
                            />
                            {FormDetail.value !== null && (
                                <Box className='w-50 ps-2'>
                                    <Typography className='text-main fw-bold' variant='body1'>{FormDetail.value} : {labels[FormDetail.value]}</Typography></Box>
                            )}
                        </Box>
                    </Box>
                </FormControl>
            )
        case "divider":
            return (
                <Divider sx={{ borderColor: 'black' }}></Divider>
            )

        default:
            break;
    }

}

export default FormComponent
